export default __webpack_public_path__ + "static/media/temperature.03e78017.png";